//=====================================================================
// Event Listener Function for single accordians
//=====================================================================
export const singleAccordianHandler = (singleAcccordians, toggleAccordianState) => {

    singleAcccordians.forEach(accordian => {
        // Remove existing handler if present
        if (accordian._clickHandler) {
            accordian.removeEventListener('click', accordian._clickHandler);
        }

        // Event Function for single items
        const clickHandler = (event) => {
            const accordionButton = accordian.querySelector('[data-accordianButton]');
            if (event.target !== accordionButton) return;

            const isActive = accordian.classList.contains("accordianIsActive");
            toggleAccordianState(accordionButton, accordian, isActive);
        };

        // Store handler reference for cleanup
        accordian._clickHandler = clickHandler;
        accordian.addEventListener('click', clickHandler);
    });
};